import { useSyncExternalStore } from "react";

import { useGlobalFlags } from "@/hooks/useGlobalFlags";
import { getBootRun, subscribeBootRun } from "@/store/bootRun";
import { type BootIndicatorLook, bootIndicatorLookFor } from "@/ui/bootIndicatorVisuals";

/**
 * The look the rail shows for the boot run, re-read whenever the run changes; `undefined` when it shows nothing.
 * Always `undefined` while the `web-bootstrap-indicator` flag is off, so the rail shows nothing and the content is
 * never dimmed.
 */
export function useBootIndicatorLook(): BootIndicatorLook | undefined {
  const { webBootstrapIndicator } = useGlobalFlags();
  // The server snapshot is the same module state, so a static render (tests) reads the live run.
  const run = useSyncExternalStore(subscribeBootRun, getBootRun, getBootRun);
  return webBootstrapIndicator === true ? bootIndicatorLookFor(run) : undefined;
}
